// extracted by mini-css-extract-plugin
module.exports = {"advertisment":"Dashboard_advertisment__2i6sU"};